import { useState } from 'react';
//mport ObservationInput from './ObservationInput';
import CustomSelect from '../../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import { TableInput } from '../../../../../../components/common';
import { top20PartWise } from '../../../helpers/getDashBoardData';

// const top20PartWise = (apiData: any) => {
//   const output = [];
//   let totalRejection = 0;
//   for (const PartName in apiData) {
//     const rejectionCount = apiData[PartName].reduce(
//       (sum: number, num: number) => sum + num
//     );
//     totalRejection += rejectionCount;
//     if (rejectionCount > 0) {
//       output.push({
//         PartName,
//         partCountDefectWise: apiData[PartName],
//         rejectionCount,
//         cummulativeRejection: 0,
//         cummPercenatge: '',
//       });
//     }
//   }
//   output.sort((a, b) => b.rejectionCount - a.rejectionCount);
//   let cumCount = 0;
//   for (const item of output) {
//     cumCount += item.rejectionCount;
//     item.cummulativeRejection = cumCount;
//     item.cummPercenatge = ((cumCount * 100) / totalRejection).toFixed(2);
//   }
//   if (output.length > 20) return output.slice(20);
//   else return output;
// };
interface IProps {
  apiData: any;
  top20?: any;
}
const TBody = ({ apiData, top20 }: IProps) => {
  return (
    <tbody>
      {top20
        ? apiData &&
          top20PartWise(apiData).map((item: any, index: number) => {
            const {
              PartName,
              partCountDefectWise,
              rejectionCount,
              cummulativeRejection,
              cummPercenatge,
            } = item;
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{PartName}</td>
                {partCountDefectWise.map((count: number) => {
                  return <td>{count}</td>;
                })}
                <td>{rejectionCount}</td>
                <td>{cummulativeRejection}</td>
                <td>{cummPercenatge}</td>
              </tr>
            );
          })
        : apiData &&
          Object.keys(apiData).map((partName: any, index: number) => {
            const partCountDefectWise = apiData[partName];
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{partName}</td>
                {partCountDefectWise.map((count: number) => {
                  return <td>{count}</td>;
                })}
                <td>
                  {partCountDefectWise.reduce(
                    (sum: number, num: number) => sum + num
                  )}
                </td>
              </tr>
            );
          })}
    </tbody>
  );
};

export default TBody;
